import { z } from 'zod'
import { zipCodeSchema } from '@/features/shared/utils/validations'

// Guest users in the Address Removal experiment can have a valid address object of just a zip_code
export const validAddressSchema = z.object({
  street1: z.string().optional(),
  street2: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  zip_code: zipCodeSchema,
  delivery_instructions: z.string().optional(),
  door_dropoff: z.boolean().optional(),
  require_validation: z.boolean().optional(),
  property_type: z.string().optional(),
  requested_delivery_location: z.string().optional(),
  shopper_arrive: z.array(z.string()).optional(),
  gate_code: z.string().optional(),
})
